import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

export const fetchCustomers = async (query) => {
  const { data } = await apiClient.get(`/customers`, { params: query.queryKey[1] });
  return data;
};

export const useGetCustomersHandler = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const [customers, setCustomers] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);
  const queryClient = useQueryClient();

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery(
    {
      queryKey: ['customers', { ...searchQuery }], // A unique key for this query
      cacheTime: 0,
      queryFn: fetchCustomers,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: 'always',
    },
    queryClient,
  );

  useEffect(() => {
    if (fetchedData) {
      setCustomers(fetchedData.content);
      setTotalDocuments(fetchedData.total_elements);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    customers,
    totalDocuments,
    isLoading,
  };
};
